import React from "react";
import { Route, Switch } from "react-router-dom";
import EditOrganizationPage from './EditOrganizationPage';
import ChangePasswordPage from './ChangePasswordPage';
import EditProfilePage from "./EditProfilePage";
// import NotificationSettings from "./NotificationSettings";

const path = "/profile";

const UserProfileRoute = () => {
    return (
        <Switch>
            <Route path={`${path}/edit-profile`} component={EditProfilePage} exact />
            <Route path={`${path}/edit-organization`} component={EditOrganizationPage} exact />
            <Route path={`${path}/change-password`} component={ChangePasswordPage} exact />
            {/* <Route path={`${path}/notification-settings`} component={NotificationSettings} exact /> */}
            <Route path="/404" />
        </Switch>
    );
};


export default UserProfileRoute;
